import React, { useState } from "react";
import { BiShareAlt, BiTrashAlt } from "react-icons/bi";
import { BsEyeFill, BsWhatsapp } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import Swal from "sweetalert2";

const BrochureCard = ({ name, url }) => {
  const pdfUrl =
    url ||
    "https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/BrochureFile_03032025171645.pdf";
  const [share, setShare] = useState(false);
  const [urls, setUrl] = useState("");

  const handleDelete = () => {
    Swal.fire({
      title: "",
      html: `
      <div style="text-align:center;">
        <div style="
          width:80px;
          height:80px;
          border-radius:50%;
          background:#ca2a2a60;
          display:flex;
          align-items:center;
          justify-content:center;
          margin:0 auto 15px;
        ">
          <i>
               <svg width="50" height="50" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" fill="#ff3434" />
        <path
        fill="none"
          d="M7 12l3 3 7-7"
          stroke="#fff"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
              </i>
        </div>
        <h4 style="color:#ff3434; margin-bottom:10px;">Remove Brochure?</h4>
        <p style="font-size:16px; color:#555;">
          Are you sure you want to remove
brochure from your list.
        
        </p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#ff3434",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };

  

  return (
    <>
      <div className="col-md-6 d-flex px-2">
        <div className="card flex-fill mb-3">
          <div className="card-body p-3">
            <div className="row">
              {/* Title */}
              <h5 className="mb-3  fw-bold text-dark text-center">{name}</h5>

              {/* PDF Viewer */}
              <div className="col-lg-12 text-center">
                <object
                  data={pdfUrl}
                  type="application/pdf"
                  width="100%"
                  height="400"
                >
                  <p>Your browser does not support PDFs.</p>
                  <a href={pdfUrl} target="_blank" rel="noreferrer">
                    Download the PDF
                    <br />
                    <img
                      src="https://erp.ravbiz.in/UploadFile/pdf-icon.jpg"
                      style={{ height: "200px" }}
                      alt="pdf"
                    />
                  </a>
                </object>
              </div>

              {/* Actions */}
              <div className="col-lg-12 mt-3 d-flex justify-content-center align-items-center text-center">
                <div className="icons-items">
                  <ul className="icons-list mb-0 text-center d-flex justify-content-center gap-3 list-unstyled">
                    {/* View */}
                    <li>
                      <a
                        href={pdfUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="badge shadow   border border-dark bg-info"
                      >
                        <BsEyeFill size={18} />
                      </a>
                    </li>

                    {/* Share Dropdown */}
                    <li className="dropdown position-relative">
                      <a
                        onClick={() => {
                          (setShare(!share), setUrl(pdfUrl));
                        }}
                        style={{ cursor: "pointer" }}
                        className="badge border border-dark bg-success"
                      >
                        <BiShareAlt size={18} />
                      </a>

                      {urls && share && (
                        <div
                          style={{ top: "20px", right: "-70px" }}
                          className="position-absolute   d-flex justify-content-center column-gap-2 bg-white p-2 px-3 shadow-lg rounded"
                        >
                          {/* WhatsApp */}
                          <a
                            className="text-success"
                            href={`https://api.whatsapp.com/send?text=Awadh City ${pdfUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <BsWhatsapp />
                          </a>

                          {/* Email */}
                          <a
                            className="text-info"
                            href={`mailto:?subject=Check out this brochure: Awadh City&body=Hi, Check this: ${pdfUrl}`}
                          >
                            <MdEmail size={18} />
                          </a>

                          {/* Facebook */}
                          <a
                            className="text-primary"
                            href={`https://www.facebook.com/sharer/sharer.php?u=${pdfUrl}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <FaFacebookSquare />
                          </a>
                        </div>
                      )}
                    </li>

                    {/* Delete */}
                    <li
                      onClick={handleDelete}
                      style={{ cursor: "pointer" }}
                      className="badge border border-dark bg-danger"
                    >
                      <BiTrashAlt size={18} />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrochureCard;
